var _defs, _path, _path2, _path3, _line, _path4, _path5, _circle, _circle2, _line2, _line3, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryMotorExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#e51753;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-dasharray:3.99 3.99;}.cls-3,.cls-4,.cls-5,.cls-6{stroke:#141414;}.cls-3{stroke-width:2px;}.cls-4,.cls-6{fill:#fff;}.cls-4{stroke-miterlimit:10;}.cls-5{fill:#e92050;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Peyk-Ersal-fori") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.4,69.8l1.3-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.8,64.9c3.1-6,5.4-16.5-7.8-26.5-7.1-5.3-18.4-4.2-28-1.6C50.9,38.4,28.9,68.5,6.1,48.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.6,47.1,3.2,45.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98,
    y1: 83.6,
    x2: 12,
    y2: 83.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.7,44.5a2.4,2.4,0,0,0,2.4-2.4V27A3.9,3.9,0,0,0,48,24.3a3.5,3.5,0,0,0-2.7-1H24.8a3.4,3.4,0,0,0-2.7,1A4,4,0,0,0,20.9,27V46.2a.7.7,0,0,0,1.1.6c1.6-1,4.9-2.5,11.4-2.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.4,51.9a1.7,1.7,0,0,0,1.8,1.3,11.8,11.8,0,0,1,7.5,1.1c.9.4,3.8,2.5,3.2,5.4a1.7,1.7,0,0,1-1.1,1.2L68.4,69.5H20.5A1.6,1.6,0,0,1,18.9,68V56.7h0c.1-.6,1.1-9.7,13.4-9.5H44s6.9-.5,7.8,4.8v3.9a1.7,1.7,0,0,0,1.6,1.7h7.7a1.7,1.7,0,0,0,1.2-.5L72,47.2a1.9,1.9,0,0,0,.5-1.4L68,29.5l-2.3.9a1.5,1.5,0,0,1-2.1-.8L61.9,26a1.5,1.5,0,0,1,.9-2.1l7.4-3.1A2.2,2.2,0,0,1,73.1,22L75,26.8a1.8,1.8,0,0,0,2,.9c2.2-.7,6.6-1.1,7.6,4.6,0,0,1.9,5.1-5.1,6.7a1.7,1.7,0,0,0-1.2,2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 37.7,
    cy: 72.1,
    r: 9.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 82.2,
    cy: 72.1,
    r: 9.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 10.3,
    y1: 16.8,
    x2: 4.7,
    y2: 22.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4.6,
    y1: 17,
    x2: 10.5,
    y2: 22.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7.6,
    y: 28.5,
    width: 22.8,
    height: 4,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.5,
    y: 37.5,
    width: 31.5,
    height: 4,
    rx: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMotorExpress);
export default __webpack_public_path__ + "static/media/Delivery_Motor_Express.192107a21ec9cd32c0b1f9ed1a7694c5.svg";
export { ForwardRef as ReactComponent };